import { useCallback, useMemo } from 'react';
import { acceptEvmOwnership as acceptEvmOwnershipAction, applyEvmMintPriceChange as applyEvmMintPriceChangeAction, cancelEvmMintPriceChange as cancelEvmMintPriceChangeAction, closeEvmMarket as closeEvmMarketAction, openEvmMarket as openEvmMarketAction, pauseEvmMinting as pauseEvmMintingAction, scheduleEvmMintPriceChange as scheduleEvmMintPriceChangeAction, setEvmMarketFee as setEvmMarketFeeAction, setEvmDefaultBatchSize as setEvmDefaultBatchSizeAction, setEvmWhitelistBatchSize as setEvmWhitelistBatchSizeAction, setEvmMaxRoyaltyBps as setEvmMaxRoyaltyBpsAction, setEvmWhitelisted as setEvmWhitelistedAction, transferEvmOwnership as transferEvmOwnershipAction, unpauseEvmMinting as unpauseEvmMintingAction, withdrawEvmMarketFee as withdrawEvmMarketFeeAction, withdrawEvmNftFee as withdrawEvmNftFeeAction, } from '../evm/evm-admin';
export function useEvmAdminActions({ activeChain, evmSigner, toast, refreshEvmGlobalState, }) {
    const deps = useMemo(() => ({
        activeChain,
        evmSigner,
        toast,
        refreshEvmGlobalState,
    }), [activeChain, evmSigner, toast, refreshEvmGlobalState]);
    const transferEvmOwnership = useCallback(async (newOwner) => {
        await transferEvmOwnershipAction(newOwner, deps);
    }, [deps]);
    const acceptEvmOwnership = useCallback(async () => {
        await acceptEvmOwnershipAction(deps);
    }, [deps]);
    const openEvmMarket = useCallback(async () => {
        await openEvmMarketAction(deps);
    }, [deps]);
    const closeEvmMarket = useCallback(async () => {
        await closeEvmMarketAction(deps);
    }, [deps]);
    const scheduleEvmMintPriceChange = useCallback(async (price) => {
        await scheduleEvmMintPriceChangeAction(price, deps);
    }, [deps]);
    const applyEvmMintPriceChange = useCallback(async () => {
        await applyEvmMintPriceChangeAction(deps);
    }, [deps]);
    const cancelEvmMintPriceChange = useCallback(async () => {
        await cancelEvmMintPriceChangeAction(deps);
    }, [deps]);
    const setEvmMarketFee = useCallback(async (fee) => {
        await setEvmMarketFeeAction(fee, deps);
    }, [deps]);
    const withdrawEvmMarketFee = useCallback(async () => {
        await withdrawEvmMarketFeeAction(deps);
    }, [deps]);
    const withdrawEvmNftFee = useCallback(async () => {
        await withdrawEvmNftFeeAction(deps);
    }, [deps]);
    const setEvmDefaultBatchSize = useCallback(async (count) => {
        await setEvmDefaultBatchSizeAction(count, deps);
    }, [deps]);
    const setEvmWhitelistBatchSize = useCallback(async (count) => {
        await setEvmWhitelistBatchSizeAction(count, deps);
    }, [deps]);
    const setEvmMaxRoyaltyBps = useCallback(async (bps) => {
        await setEvmMaxRoyaltyBpsAction(bps, deps);
    }, [deps]);
    const pauseEvmMinting = useCallback(async () => {
        await pauseEvmMintingAction(deps);
    }, [deps]);
    const unpauseEvmMinting = useCallback(async () => {
        await unpauseEvmMintingAction(deps);
    }, [deps]);
    const setEvmWhitelisted = useCallback(async (account, allowed) => {
        await setEvmWhitelistedAction(account, allowed, deps);
    }, [deps]);
    return {
        transferEvmOwnership,
        acceptEvmOwnership,
        openEvmMarket,
        closeEvmMarket,
        scheduleEvmMintPriceChange,
        applyEvmMintPriceChange,
        cancelEvmMintPriceChange,
        setEvmMarketFee,
        withdrawEvmMarketFee,
        withdrawEvmNftFee,
        setEvmDefaultBatchSize,
        setEvmWhitelistBatchSize,
        setEvmMaxRoyaltyBps,
        pauseEvmMinting,
        unpauseEvmMinting,
        setEvmWhitelisted,
    };
}
